import React, { useEffect, useState } from "react";

interface DateProps {
  field_name: string;
  handleInputChange: (event: { name: string; value: string }) => void;
  disablePast?: boolean;
}

const CommonDateTimePicker: React.FC<DateProps> = ({
  field_name,
  handleInputChange,
  disablePast = false,
}) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    const flatpickr = (window as any).flatpickr;

    if (!flatpickr) return;

    const inputElement = document.getElementById(
      `${field_name}_date`
    ) as HTMLInputElement;

    if (!inputElement) return;

    const fp = flatpickr(inputElement, {
      enableTime: false, // ✅ ONLY DATE
      dateFormat: "Y-m-d",
      ...(disablePast && { minDate: "today" }),

      onChange: (selectedDates: Date[]) => {
        if (selectedDates.length > 0) {
          const d = selectedDates[0];
          const formatted =
            d.getFullYear() +
            "-" +
            String(d.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(d.getDate()).padStart(2, "0");

          setDate(formatted);
        }
      },
    });

    return () => fp.destroy();
  }, [field_name, disablePast]);

  // ✅ combine date + time
  useEffect(() => {
    if (date && time) {
      handleInputChange({
        name: field_name,
        value: `${date} ${time}`,
      });
    }
  }, [date, time]);

  return (
    <div className="d-flex gap-3">
      {/* DATE */}
      <div className="position-relative w-50">
        <i className="ki-outline ki-calendar-8 position-absolute ms-4 mt-3 fs-2"></i>
        <input
          type="text"
          id={`${field_name}_date`}
          className="form-control form-control-solid ps-12"
          placeholder="Select date"
          readOnly
        />
      </div>

      {/* TIME */}
      <div className="position-relative w-50">
        <i className="ki-outline ki-time position-absolute ms-4 mt-3 fs-2"></i>
        <input
          type="time"
          className="form-control form-control-solid ps-12"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CommonDateTimePicker;